import { api } from '@general/ui-kit'

/**
 * The sites of the one company, in one place.
 *
 * A helper and not `api.get('/sites', …)` at each call site, because the second
 * argument of the client is OPTIONS and not query parameters — `{ params }` is
 * the field that becomes a query string. Three screens had been passing
 * `{ active: true }` and `{ search }` straight through, which the client
 * silently drops: the search box on the list filtered nothing, and every
 * selector kept offering sites that had been closed.
 */
export const sitesApi = {
  list: (params = {}) => api.get('/sites', { params }),
  get: (id) => api.get(`/sites/${id}`),
  create: (body) => api.post('/sites', body),
  update: (id, body) => api.patch(`/sites/${id}`, body),
  // No DELETE anywhere: a site is closed, and everything that names it keeps
  // reading. See closeSite() in the backend.
  close: (id) => api.post(`/sites/${id}/close`),
}
